import Phaser from 'phaser';

export type EnemyBulletKind = 'straight' | 'homing' | 'lob';

/**
 * 敌方投射物（对象池化）
 *  - straight：直线飞行
 *  - homing：缓慢转向玩家（由 GameScene 每帧制导）
 *  - lob：抛物线炸弹，抵达/撞墙时爆炸
 */
export default class EnemyBullet extends Phaser.Physics.Arcade.Sprite {
  damage = 10;
  kind: EnemyBulletKind = 'straight';
  /** 追踪弹转向速率（弧度/秒） */
  turnRate = 3.2;
  /** 爆炸半径（lob / 自爆用，0 表示不爆炸） */
  explodeRadius = 0;
  /** 到点/超时后是否爆炸 */
  willExplode = false;
  shotCount = 0;
  /** 到期回调（由 GameScene 设置，用于爆炸） */
  onExpire?: () => void;

  constructor(scene: Phaser.Scene, x: number, y: number, key = 'bullet_enemy') {
    super(scene, x, y, key);
    scene.add.existing(this);
    scene.physics.add.existing(this);
    this.setImmovable(true);
    (this.body as Phaser.Physics.Arcade.Body).allowGravity = false;
    this.body?.setSize(12, 12);
    this.setOrigin(0.5, 0.5);
    this.deactivate();
  }

  launch(
    x: number,
    y: number,
    angle: number,
    speed: number,
    damage: number,
    kind: EnemyBulletKind,
    life = 3000,
    explodeRadius = 0,
    tint = 0xffffff,
    textureKey = 'bullet_enemy'
  ) {
    this.shotCount += 1;
    this.setTexture(textureKey);
    this.setActive(true).setVisible(true);
    const body = this.body as Phaser.Physics.Arcade.Body;
    body.enable = true;
    body.reset(x, y);
    body.allowGravity = false;
    this.damage = damage;
    this.kind = kind;
    this.explodeRadius = explodeRadius;
    this.willExplode = kind === 'lob' && explodeRadius > 0;
    this.setTint(tint);
    this.setScale(kind === 'lob' ? 1.1 : 1);
    body.setVelocity(Math.cos(angle) * speed, Math.sin(angle) * speed);
    this.setAngle(Phaser.Math.RadToDeg(angle));

    const token = this.shotCount;
    this.scene.time.delayedCall(life, () => {
      if (this.active && this.shotCount === token) this.expire();
    });
  }

  /** 自然到期：有爆炸半径则交由世界处理爆炸，否则回收 */
  expire() {
    if (this.willExplode && this.onExpire) this.onExpire();
    else this.deactivate();
  }

  deactivate() {
    this.onExpire = undefined;
    this.setActive(false).setVisible(false);
    const body = this.body as Phaser.Physics.Arcade.Body;
    if (body) {
      body.stop();
      body.enable = false;
    }
  }
}
